import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import React, { useEffect, useState } from "react";

const MuiConfirmWindow = (props) => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    setOpen(props.open);
  }, [props.open]);

  const handleClose = () => {
    if (props.onClose) props.onClose();
  };

  const handleOkClick = () => {
    if (props.onSuccess) props.onSuccess();
    else if (props.onClose) props.onClose();
  };

  return (
    <>
      <Dialog open={open} onClose={handleClose}>
        {props.title && (
          <DialogTitle id="alert-dialog-title">{props.title}</DialogTitle>
        )}

        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {props.children}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          {props.cancelText && (
            <Button onClick={(e) => handleClose()}>{props.cancelText}</Button>
          )}
          <Button onClick={(e) => handleOkClick()} autoFocus>
            {props.okText || "Ok"}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default MuiConfirmWindow;
